export const findFavouritesOfShooting = (shooting) => {
    const favourites = shooting.pictures ? shooting.pictures.filter((picture) => picture.isFavourite) : [];
    return favourites;
    };